import { Button } from "@/components/ui/button";
import { useNavigate } from "@tanstack/react-router";

interface NavbarMinimalProps {
	breadcrumb?: React.ReactNode;
}

const NavbarMinimal: React.FC<NavbarMinimalProps> = () => {
	const navigate = useNavigate();
	const handleLogoClick = () => {
		if (window.location.pathname === "/") {
			window.location.reload();
		}
		else {
			navigate({ to: "/" });
		}
	};
	return (
		<>
			{/* Navbar */}
			<nav
				className="bg-gradient-to-b from-[#3F2EC8] to-[#1F1762] px-2 sm:px-4 pt-4 pb-2 flex flex-col gap-0 shadow fixed top-0 left-0 w-full z-50"
				style={{ minHeight: 80 }}
			>
				{/* Top Row */}
				<div className="flex items-center w-full px-2 sm:px-6">
					{/* Logo */}
					<Button
						variant="ghost"
						size="icon"
						tabIndex={0}
						aria-label="Intasida Home Logo Button"
						className="p-0 rounded-none hover:bg-transparent focus:bg-transparent"
						onClick={handleLogoClick}
					>
						<img src="/intasida-icon.svg" alt="Logo" className="w-8 h-10" />
					</Button>
				</div>

			</nav>
			{/* Spacer for fixed navbar (adjusted for minimal navbar height) */}
			<div style={{ height: 85 }} />
			{/* Delivery Guarantee Section */}
			<section
				className="w-full flex justify-center bg-[#E2E1EB]"
				style={{
					minHeight: 42,
					paddingTop: 4,
					paddingBottom: 4,
					paddingLeft: 80,
					paddingRight: 80
				}}
			>
				<div
					className="flex flex-col gap-1 w-full"
					style={{ maxWidth: 1280, minHeight: 34, gap: 6 }}
				>
					<div
						className="flex items-center gap-1.5"
						style={{ minHeight: 14, gap: 6 }}
					>
						<img
							src="/assets/icons/group.svg"
							alt="Delivery Guarantee"
							style={{ width: 14, height: 14, opacity: 1 }}
						/>
						<span
							style={{
								color: "#2A2A2A",
								fontFamily: "Inter, sans-serif",
								fontWeight: 500,
								fontSize: 12,
								lineHeight: "103%",
								letterSpacing: "-0.07em",
								opacity: 1
							}}
						>
							Delivery guarantee
						</span>
					</div>
					<span
						style={{
							color: "#6F6F6F",
							fontFamily: "Inter, sans-serif",
							fontWeight: 400,
							fontSize: 12,
							lineHeight: "120%",
							letterSpacing: 0,
							opacity: 1
						}}
					>
						Refund for any issue
					</span>
				</div>
			</section>

		</>
	);
};

export default NavbarMinimal;
